import type { EditImageRequest, EditImageResponse } from '@pulsify/shared/dto'
import { adminBypassHeaders } from '~/app/admin-bypass'
import { api, getAuthToken, unwrap } from '~/shared/lib/rpc'

export const editApi = {
  async apply(
    businessId: string,
    file: File,
    params: EditImageRequest,
  ): Promise<EditImageResponse> {
    const url = api.api.businesses[':businessId']['ai-studio'].edit.$url({
      param: { businessId },
    })
    const formData = new FormData()
    formData.append('file', file)
    formData.append('params', JSON.stringify(params))
    const token = await getAuthToken()
    const headers: Record<string, string> = { ...adminBypassHeaders() }
    if (token) headers.Authorization = `Bearer ${token}`
    const res = await fetch(url, { method: 'POST', body: formData, headers })
    return unwrap<EditImageResponse>(res)
  },
}
